// extracted by mini-css-extract-plugin
module.exports = {"name":"productloadinglist_name__MKTNj","animated-background":"productloadinglist_animated-background__wTal_","placeHolderShimmer":"productloadinglist_placeHolderShimmer__1GwzN"};